module.exports = __webpack_public_path__ + "static/img/icon_rjyf_rjfw_zl.2c0af4e2.png";